<template>
  <div>
    <ItcShare v-if="isTencentCloud && id > 84" />
    <RoutineShare v-else />
  </div>
</template>

<script>
export default {
  components: {
    ItcShare: () => import("./album-sharePage/itc-album-sharePage.vue"),
    RoutineShare: () => import("./album-sharePage/routine-album-sharePage.vue"),
  },
  computed: {
    isTencentCloud() {
      return sessionStorage.getItem("tencentCloud") === "1" ? true : false;
    },
    id() {
      return parseInt(this.$route.query.id);
    },
  },
};
</script>

<style scoped lang='scss'>
</style>
